import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { registerSW } from 'virtual:pwa-register';
import App from './App.vue';
import router from './router/index.js';
import { i18n } from './i18n/index.js';
import { useLocaleStore } from '@/stores/locale.js';
import { useAuthStore } from '@/stores/auth.js';
import { useThemeStore } from '@/stores/theme.js';
import './assets/main.css';

// Theme sofort anwenden bevor die App gemountet wird (verhindert Flash)
const savedTheme = localStorage.getItem('theme') || 'dark';
document.documentElement.setAttribute('data-theme', savedTheme);

const app = createApp(App);
const pinia = createPinia();
app.use(pinia);
app.use(i18n);
app.use(router);

const localeStore = useLocaleStore(pinia);
localeStore.init();
const themeStore = useThemeStore(pinia);
themeStore.init();

app.mount('#app');

// Nach dem Mount die Sprache des angemeldeten Benutzers laden wenn vorhanden
const authStore = useAuthStore(pinia);
if (authStore.isLoggedIn && authStore.user?.language) {
  localeStore.setLocale(authStore.user.language, { syncBackend: false });
}
if (authStore.isLoggedIn && authStore.user?.theme) {
  themeStore.setTheme(authStore.user.theme, { syncBackend: false });
}

// Service Worker registrieren — auto-update wenn neue Version verfügbar
registerSW({ onNeedRefresh() {}, onOfflineReady() {} });